import { render, staticRenderFns } from "./NudgePopup.vue?vue&type=template&id=90d504a0&scoped=true"
import script from "./NudgePopup.vue?vue&type=script&lang=js"
export * from "./NudgePopup.vue?vue&type=script&lang=js"
import style0 from "./NudgePopup.vue?vue&type=style&index=0&id=90d504a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d504a0",
  null
  
)

export default component.exports